import React, { FC } from 'react';
import * as S from './styles';

interface ICheckbox {
  name: string;
  value: string;
  checked: boolean;
  onChange: any;
  disabled: any;
}

const CheckboxInput: FC<ICheckbox> = ({ name, checked, onChange, disabled, value }) => {
  return <S.CheckboxInput
    type="checkbox"
    name={name}
    value={value}
    checked={checked ? checked : false}
    onChange={onChange}
    disabled={disabled}
    data-testid="checkbox-TRow-TableDetails"
  />;
};

export default CheckboxInput;
